
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import * as Enum from '@/enum';
import store from '@/store';
import { AgentSubscriptionRequestClient, LoginClient } from '@/services/Services';
import { LoginServices } from '@/services/LoginServices';
import {Watch} from 'vue-property-decorator';
import {UploadServices} from '@/services/UploadServices';

@Options({})
export default class profilePage extends Vue {

    fileToUpload: File = null;

    logout(){
        LoginServices.logout()
        .then(x => {
            this.$router.replace("/");
        })
    }

    @Watch('fileToUpload')
    onFileToUpload(){
        UploadServices.UploadUserImage({
            entityIdentifier: store.state.user.identifier,
            file: this.fileToUpload
        })
        .then(x => {
            store.state.user.personalData.profilePicture = x;
        })
    }

    goToAgentSubscription(){
        if(store.state.agentSubscription){
            this.$router.push('/network/agentSubscription');
        } else {
            AgentSubscriptionRequestClient.getPendingByUser(store.state.user.identifier)
            .then(x => {
                if(x){
                    this.$router.push('/network/agentSubscriptionRequest');
                } else {
                    this.$router.push('/network/agentSubscriptionLanding');
                }
            })
        }
    }

}
